export default {
    props: {
        footerSections: {
            required: true,
            type: Array,
        },
    },
}
